export function isExpired(token) {
  if (!token || typeof token !== "string") {
    return true;
  }

  try {
    const parts = token.split(".");

    if (parts.length < 2) {
      return true;
    }

    const base64Payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = base64Payload.padEnd(
      Math.ceil(base64Payload.length / 4) * 4,
      "="
    );
    const payload = JSON.parse(atob(paddedPayload));
    const now = Math.floor(Date.now() / 1000);
    if (!payload.exp) {
      return false
    }
    return typeof payload.exp !== "number" || payload.exp < now;
  } catch (error) {
    return true;
  }
}
